export default __webpack_public_path__ + "static/media/notification.fe8f4746.mp3";